"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRESENT = exports.LEAVE = exports.ENTER = exports.CONNECTION_STATUSES = exports.ABLY_PRESENCE_SUBSCRIBE_CHANNEL_MODE = exports.ABLY_PRESENCE_ACTIONS_MAP = exports.ABLY_DEFAULT_CHANNEL_MODES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../shared/constants");

var _ABLY_PRESENCE_ACTION;

var ENTER = 'enter';
exports.ENTER = ENTER;
var LEAVE = 'leave';
exports.LEAVE = LEAVE;
var PRESENT = 'present';
exports.PRESENT = PRESENT;
var ABLY_PRESENCE_ACTIONS_MAP = (_ABLY_PRESENCE_ACTION = {}, (0, _defineProperty2.default)(_ABLY_PRESENCE_ACTION, ENTER, _constants.PRESENCE_ACTIONS.JOIN), (0, _defineProperty2.default)(_ABLY_PRESENCE_ACTION, LEAVE, _constants.PRESENCE_ACTIONS.LEAVE), (0, _defineProperty2.default)(_ABLY_PRESENCE_ACTION, PRESENT, _constants.PRESENCE_ACTIONS.JOIN), _ABLY_PRESENCE_ACTION);
exports.ABLY_PRESENCE_ACTIONS_MAP = ABLY_PRESENCE_ACTIONS_MAP;
var ABLY_DEFAULT_CHANNEL_MODES = ['PRESENCE', 'SUBSCRIBE', 'PUBLISH'];
exports.ABLY_DEFAULT_CHANNEL_MODES = ABLY_DEFAULT_CHANNEL_MODES;
var ABLY_PRESENCE_SUBSCRIBE_CHANNEL_MODE = 'PRESENCE_SUBSCRIBE';
exports.ABLY_PRESENCE_SUBSCRIBE_CHANNEL_MODE = ABLY_PRESENCE_SUBSCRIBE_CHANNEL_MODE;
var CONNECTION_STATUSES = {
  CONNECTED: 'connected',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected'
};
exports.CONNECTION_STATUSES = CONNECTION_STATUSES;
//# sourceMappingURL=ablyConstants.js.map